export interface CatalogLoginSdk {
  login: (callback: (response: { authResponse?: { code?: string } }) => void, options: {
    config_id: string
    response_type: 'code'
    override_default_response_type: true
    extras: { features: { name: 'app_only_install' }[] }
  }) => void
}

export function requestCatalogAuthorization (
  sdk: CatalogLoginSdk | undefined, configId: string, signal?: AbortSignal
): Promise<string | undefined> {
  if (!/^\d+$/.test(configId)) return Promise.reject(new Error('Catalog authorization is not configured for this environment.'))
  if (!sdk) return Promise.reject(new Error('Facebook login is not ready. Reload the page and try again.'))
  if (signal?.aborted) return Promise.resolve(undefined)

  return new Promise((resolve, reject) => {
    let settled = false
    const cleanup = () => {
      clearTimeout(timeout)
      signal?.removeEventListener('abort', onAbort)
    }
    const finish = (code?: string) => {
      if (settled) return
      settled = true
      cleanup()
      resolve(code)
    }
    const onAbort = () => finish()
    const timeout = setTimeout(() => {
      if (settled) return
      settled = true
      cleanup()
      reject(new Error('Meta authorization timed out. Close the login window and try again.'))
    }, 120000)
    signal?.addEventListener('abort', onAbort, { once: true })
    try {
      sdk.login(response => {
        const code = response.authResponse?.code
        finish(typeof code === 'string' && code.trim() ? code : undefined)
      }, {
        config_id: configId,
        response_type: 'code',
        override_default_response_type: true,
        // Catalog operations also need the existing WABA asset grant. Do not
        // route this authorization through phone registration or onboarding.
        extras: { features: [{ name: 'app_only_install' }] }
      })
    } catch {
      if (settled) return
      settled = true
      cleanup()
      reject(new Error('Facebook login could not be opened. Please try again.'))
    }
  })
}
